import React from 'react'
// import { CodeIcon } from "@heroicons/react/solid";

export default function Github() {
  return (
    <section id="githubstats" data-aos="flip-up" data-aos-duration="1000"className="container px-5 py-10 mx-auto">
          <div className="flex flex-col w-full px-10 mb-10 ">
          {/* <CodeIcon className="mx-auto inline-block w-10 mb-4" /> */}
          <h1 className="sm:text-4xl text-3xl font-medium title-font mb-4 text-white mx-auto" >
       Github Statistics
          </h1>
        </div>
        <img className='border-solid border-2 border- w-full '  alt="Gaurav's Activity Graph" src="https://activity-graph.herokuapp.com/graph?username=GauravMishra28&bg_color=green&color=#16a34a&line=#16a34a&point=FFFFFF&hide_border=true"></img>
      <div>
     {/* <img className='h-40 mr-2' alt="stats" src="https://github-readme-stats.vercel.app/api?username=GauravMishra28&show_icons=true&theme=transparent" />
      
     <img  className='h-40 mr-2'src="https://github-readme-stats.vercel.app/api/top-langs/?username=GauravMishra28&theme=transparent"/> */}
     <img  className='mx-auto mt-5' alt="demo" src="https://streak-stats.demolab.com/?user=GauravMishra28&theme=android-dark)"/>
     </div>
   
    </section>
  )
}



// WEBPACK FOOTER //
// ./src/components/github.js